import { BackPage } from "./backPage";
import { Select } from "./select";

export function ViewSelect({ components, backPage }) {
  return (
    <div className="flex flex-col gap-2 px-2 mt-6 pb-8">
      {components.map((item, idx) => (
        <Select id={item.id} key={idx + 1} idx={idx + 1} label={item.label} />
      ))}
      <BackPage href={backPage} />
    </div>
  )
}